export const PUBLIC_OFFER_LINK = '/documents/public-offer.pdf';
export const USER_AGREEMENT_LINK = '/documents/user-agreement.pdf';
export const PRIVACY_POLICY_LINK = '/documents/privacy-policy.pdf';
export const PAYMENT_AND_RETURN_PRODUCT_RULES_LINK = '/documents/payment-and-return-product-rules.pdf';
